module.exports = __webpack_public_path__ + "static/media/brian.23e79181.png";